<template>
  <div>
    <section
      v-if="Object.keys(item).length"
      id="pricing-plan"
    >
      <!-- Detalles de periodo y calendario -->
      <b-row class="pricing-card">
        <b-col>
          <b-row>
            <b-col
              xl="5"
              lg="6"
              md="12"
            >
              <detail
                :periodo="item"
                @will-edit="$emit('will-edit', item.id)"
              />
            </b-col>

            <b-col
              xl="7"
              lg="6"
              md="12"
            >
              <scheadule :periodo="item.id || null" />
            </b-col>

          </b-row>
        </b-col>
      </b-row>
    </section>
    <b-card
      v-else
      class="text-center py-3"
    >
      <span class="text-muted">
        Seleccione un periodo para ver sus detalles
      </span>

    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Scheadule from './components/Scheadule.vue'
import Detail from './components/Detail.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,

    Scheadule,
    Detail,
  },
  directives: {
    Ripple,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-pricing.scss';
</style>
